export default __webpack_public_path__ + "static/media/platform1.f1dbb176.png";